import user from "@/utils/user";


export default {
    user
}
